/*
 * oc-behaviors.js — comportamientos UI Overcloud
 * 1. IntersectionObserver para `.oc-scroll-in` (banda Hecho en Colombia)
 * 2. Crossfade de imagen en product cards con `[data-oc-card]`
 * Cargado con `defer` por snippets/oc-head.liquid
 */
(function () {
  'use strict';

  // 1. Scroll-in reveal
  var scrollTargets = document.querySelectorAll('.oc-scroll-in');
  if (scrollTargets.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    scrollTargets.forEach(function (el) { io.observe(el); });
  } else {
    scrollTargets.forEach(function (el) { el.classList.add('is-in'); });
  }

  // 2. Product card crossfade
  var cards = document.querySelectorAll('[data-oc-card]');
  cards.forEach(function (card) {
    var enter = function () { card.classList.add('is-hovered'); };
    var leave = function () { card.classList.remove('is-hovered'); };
    card.addEventListener('mouseenter', enter);
    card.addEventListener('mouseleave', leave);
    card.addEventListener('focusin', enter);
    card.addEventListener('focusout', leave);
  });

  // 3. Carrusel — flechas + contador + autoplay + loop infinito (clones)
  function initCarousel(root) {
    if (!root || root.dataset.ocCarouselInit === '1') return;
    var track = root.querySelector('[data-oc-carousel-track]');
    if (!track) return;
    var section = root.closest('[data-oc-carousel-section]') || root.closest('.oc-featcoll');
    if (!section) return;
    var nav = section.querySelector('[data-oc-carousel-nav]');
    var prev = nav ? nav.querySelector('[data-oc-carousel-prev]') : null;
    var next = nav ? nav.querySelector('[data-oc-carousel-next]') : null;
    var counter = nav ? nav.querySelector('[data-oc-carousel-counter]') : null;
    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-oc-carousel-item]'));
    var total = originals.length;
    if (total === 0) return;
    root.dataset.ocCarouselInit = '1';

    var autoplayMs = parseInt(root.getAttribute('data-oc-autoplay-ms'), 10) || 0;
    var loop = root.getAttribute('data-oc-autoplay-loop') !== 'false';
    var seamless = loop && total > 1;

    if (seamless) {
      var leadClone = originals[total - 1].cloneNode(true);
      var tailClone = originals[0].cloneNode(true);
      leadClone.setAttribute('aria-hidden', 'true');
      tailClone.setAttribute('aria-hidden', 'true');
      leadClone.classList.add('oc-pcar__slide--clone');
      tailClone.classList.add('oc-pcar__slide--clone');
      track.insertBefore(leadClone, originals[0]);
      track.appendChild(tailClone);
    }

    var items = track.querySelectorAll('[data-oc-carousel-item]');

    function step() {
      if (items.length < 2) return track.clientWidth;
      var a = items[0].getBoundingClientRect();
      var b = items[1].getBoundingClientRect();
      return Math.max(1, b.left - a.left);
    }

    function visualIndex() {
      var s = step();
      return Math.round(track.scrollLeft / s);
    }

    function realIndex() {
      if (!seamless) return visualIndex();
      var i = visualIndex() - 1;
      if (i < 0) return total - 1;
      if (i >= total) return 0;
      return i;
    }

    function update() {
      var i = realIndex();
      if (counter) counter.textContent = (i + 1) + '/' + total;
      if (seamless) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
      } else {
        if (prev) prev.disabled = !autoplayMs && i <= 0;
        if (next) next.disabled = !autoplayMs && i >= total - 1;
      }
    }

    function setScrollNoAnim(left) {
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      // forzar reflow para que el cambio se materialice antes de restaurar
      void track.offsetWidth;
      track.style.scrollBehavior = prevBehavior;
    }

    function snapIfOnClone() {
      if (!seamless) return;
      var vi = visualIndex();
      if (vi === 0) {
        setScrollNoAnim(step() * total);
      } else if (vi === total + 1) {
        setScrollNoAnim(step());
      }
      update();
    }

    function placeInitial() {
      if (seamless) setScrollNoAnim(step());
    }
    // Esperar layout antes de posicionar inicial
    if (seamless) requestAnimationFrame(placeInitial);

    function advance() { track.scrollBy({ left: step(), behavior: 'smooth' }); }
    function backward() { track.scrollBy({ left: -step(), behavior: 'smooth' }); }

    if (prev) prev.addEventListener('click', backward);
    if (next) next.addEventListener('click', advance);

    var t;
    var snapTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(update, 80);
      if (seamless) {
        clearTimeout(snapTimer);
        snapTimer = setTimeout(snapIfOnClone, 550);
      }
    });
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { update(); placeInitial(); }, 120);
    });
    update();

    if (autoplayMs > 0) {
      var timer = null;
      var paused = false;
      function start() { if (!timer && !paused) timer = setInterval(advance, autoplayMs); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function pause() { paused = true; stop(); }
      function resume() { paused = false; start(); }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      start();
    }
  }

  function initAllCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-oc-carousel-root]').forEach(initCarousel);
  }
  initAllCarousels();

  // Re-init en el editor de Shopify cuando se carga/edita una sección
  document.addEventListener('shopify:section:load', function (e) {
    initAllCarousels(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    initAllCarousels(e.target);
  });

  // 4. Quick add — pills de talla en oc-card-product-quick → abre cart drawer
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.oc-qcard__pill');
    if (!pill || pill.disabled || pill.classList.contains('is-loading')) return;
    var variantId = pill.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    var originalText = pill.textContent;
    pill.classList.add('is-loading');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        pill.classList.remove('is-loading');
        if (response.status) {
          throw new Error(response.description || response.message || 'cart-error');
        }
        pill.classList.add('is-added');
        pill.textContent = '✓';
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          // fallback sin web component → refresca bubble
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var bubbleHost = document.getElementById('cart-icon-bubble');
            if (bubbleHost) {
              bubbleHost.innerHTML = '<div class="cart-count-bubble"><span aria-hidden="true">' + c.item_count + '</span><span class="visually-hidden">' + c.item_count + ' artículos</span></div>';
            }
          });
        }
        setTimeout(function () {
          pill.classList.remove('is-added');
          pill.textContent = originalText;
        }, 1200);
      })
      .catch(function () {
        pill.classList.remove('is-loading');
        pill.classList.add('is-error');
        pill.textContent = '!';
        setTimeout(function () {
          pill.classList.remove('is-error');
          pill.textContent = originalText;
        }, 1500);
      });
  });
})();

/*
 * Smart section anchors — resuelve slugs cortos a IDs reales de Shopify.
 * En JSON templates, un section con key "new-arrivals" se renderiza como
 * id="shopify-section-template--<themeId>__new-arrivals". El usuario no
 * puede predecir ese ID, así que dejamos que use links como #new-arrivals
 * o /#new-arrivals y aquí los resolvemos.
 */
(function(){
  function findByKey(key) {
    if (!key) return null;
    var el = document.getElementById(key);
    if (el) return el;
    el = document.getElementById('shopify-section-' + key);
    if (el) return el;
    // Match cualquier shopify-section-...__<key>
    return document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]');
  }
  function scrollToKey(key, smooth) {
    var target = findByKey(key);
    if (!target) return false;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    return true;
  }
  // On page load: si veníamos con hash desde otra página, resolver.
  function handleInitialHash() {
    var hash = location.hash.replace(/^#/, '');
    if (!hash) return;
    if (document.getElementById(hash)) return; // ya lo encontró el browser, no interfiero
    // Esperar un tick para que el layout esté listo
    requestAnimationFrame(function(){ scrollToKey(hash, false); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
  // Clicks: si el href apunta al mismo path pero con hash que no existe como id, resolver.
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('#') === -1) return;
    var url;
    try { url = new URL(a.href, location.href); } catch(_) { return; }
    var samePage = url.pathname === location.pathname && url.search === location.search;
    if (!samePage) return; // navegación normal
    var key = url.hash.replace(/^#/, '');
    if (!key) return;
    if (document.getElementById(key)) return; // ancla nativa existe
    if (scrollToKey(key, true)) {
      e.preventDefault();
      history.replaceState(null, '', '#' + key);
    }
  });
})();

/*
 * <product-recommendations data-product-id="X" data-limit="4">
 * Carga el grid de recomendaciones desde Shopify (/recommendations/products)
 * y lo inyecta. Se ejecuta también cuando el drawer se re-renderiza vía AJAX
 * (innerHTML reemplazado), porque connectedCallback dispara al insertar el nodo.
 */
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      var pid = this.dataset.productId;
      var limit = this.dataset.limit || 4;
      if (!pid) return;
      var url = '/recommendations/products?section_id=cart-recommendations&product_id=' + encodeURIComponent(pid) + '&limit=' + encodeURIComponent(limit) + '&intent=related';
      var self = this;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.shopify-section') || doc.body;
          if (!content) return;
          var inner = content.innerHTML.trim();
          if (!inner) return;
          self.innerHTML = inner;
          self.setAttribute('loaded', '');
        })
        .catch(function () { /* silent fail — sin recos no rompe drawer */ });
    }
  });
}

/*
 * <oc-fit-title data-max-size="32" data-min-size="14">
 *   <h1>Product title</h1>
 * </oc-fit-title>
 *
 * Ajusta el tamaño del texto para que quepa en UNA sola línea.
 * Empieza en data-max-size y baja de 1 en 1px hasta que scrollWidth <= clientWidth,
 * con floor en data-min-size (si tras llegar al min no cabe, se queda en min y se acepta el wrap).
 * Re-fitea al cambiar tamaño del contenedor (ResizeObserver).
 */
if (!customElements.get('oc-fit-title')) {
  customElements.define('oc-fit-title', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._fit = function () { self.fit(); };
      // fit inicial (rAF para asegurar layout listo)
      requestAnimationFrame(this._fit);
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._fit);
        this._ro.observe(this);
      } else {
        window.addEventListener('resize', this._fit);
      }
    }
    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      else window.removeEventListener('resize', this._fit);
    }
    fit() {
      var target = this.querySelector('.oc-fit-target') || this.querySelector('h1, h2');
      if (!target) return;
      var maxSize = parseFloat(this.dataset.maxSize || '32');
      var minSize = parseFloat(this.dataset.minSize || '14');
      // Reset a max
      target.style.whiteSpace = 'nowrap';
      target.style.fontSize = maxSize + 'px';
      var container = this.clientWidth;
      if (container <= 0) return;
      var size = maxSize;
      // Bajar hasta que quepa o llegar al mínimo
      while (target.scrollWidth > container && size > minSize) {
        size -= 1;
        target.style.fontSize = size + 'px';
      }
      // Si sigue overflowing en el mínimo, permitir wrap (mejor legibilidad que overflow oculto)
      if (target.scrollWidth > container) {
        target.style.whiteSpace = 'normal';
      }
    }
  });
}
